import Image from 'components/Common/Image/Image'
import Spacing from 'components/Common/Spacing'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { LFSEOfferType, LOOKING_FOR_SOMETHING_ELSE_CONTENT } from './constants'
import { capitalise } from 'lib/string/stringUtils'
import LineAngleRightIcon from 'components/Luxkit/Icons/line/LineAngleRightIcon'
import { getNavItems } from 'selectors/navigationSelectors'
import { connect } from 'react-redux'
import Clickable from 'components/Common/Clickable/Clickable'

const StyledGroup = styled(Group)`
  background: ${({ theme }) => theme.palette.neutral.default.eight};
  width: ${rem(240)};
`

const StyledSpacing = styled(Spacing)`
  width: 100%;
`

interface MappedProps {
  navItems: Array<App.NavItem>;
}

function LFSEOfferTypeTiles({ navItems }: MappedProps) {
  const offerTypes = [LFSEOfferType.Hotel, LFSEOfferType.Tours, LFSEOfferType.Cruises, LFSEOfferType.Experiences]
  const contentList = offerTypes.map(offerType => LOOKING_FOR_SOMETHING_ELSE_CONTENT[offerType]).filter(offerTypeContent => navItems.find(navItem => navItem.to === offerTypeContent.to))

  return (
    <>
      {contentList.map(content => (
        <Clickable key={content.to} href={content.to}>
          <StyledGroup direction="horizontal" verticalAlign="center">
            <Image dpr={3} aspectRatio="1:1" id={content.imageId!!} width={48} height={48} />
            <StyledSpacing ml={12} mr={12}>
              <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center">
                <BodyText variant="medium" weight="bold">{capitalise(content.label)}</BodyText>
                <LineAngleRightIcon />
              </Group>
            </StyledSpacing>
          </StyledGroup>
        </Clickable>
      ))}
    </>
  )
}

function mapStateToProps(state: App.State): MappedProps {
  return {
    navItems: getNavItems(state),
  }
}

export default connect(mapStateToProps)(LFSEOfferTypeTiles)
